// src/components/sections/thinkware/EtThinkWareCTA.jsx

import React from "react";
import { motion } from "framer-motion";
import { RocketLaunchIcon } from "@heroicons/react/24/outline";

const EtThinkWareCTA = () => {
  // First Created – 22 Nov 2025
  // Author – Atul Pandey
  // Purpose – Connect ThinkWare → Trinity Platform

  return (
    <section
      id="thinkware-cta"
      className="py-20 bg-gradient-to-r from-orange-700 via-orange-600 to-orange-500 text-white text-center relative overflow-hidden"
    >
      {/* Texture Overlay */}
      <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>

      {/* Content Container */}
      <motion.div
        className="relative z-10 max-w-3xl mx-auto px-4"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        {/* Heading */}
        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          Turn Insight Into Transformation
        </h2>

        {/* Subtext */}
        <p className="text-lg text-orange-100 mb-8 leading-relaxed">
          You've sparked a Thinking Shift.  
          Now accelerate your growth journey with Trinity —  
          where purpose, clarity, and execution come together through AI-guided workflows.
        </p>

        {/* CTA Button */}
        <motion.a
          href="/trinity/platform"
          className="inline-flex items-center gap-2 px-6 py-3 bg-white text-orange-600 font-semibold rounded-lg shadow-lg hover:bg-gray-100 transition"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <RocketLaunchIcon className="h-6 w-6" />
          Explore Trinity
        </motion.a>

        {/* Optional second CTA (retain or remove) */}
        {/* <div className="mt-4">
          <a
            href="/#contact"
            className="text-white/90 underline hover:text-white transition text-sm"
          >
            Book a conversation
          </a>
        </div> */}
      </motion.div>
    </section>
  );
};

export default EtThinkWareCTA;